<template>
  <div class="container-fluid verify-wrapper">
    <div class="verify-container">
      <div class="auth-header">
        <div class="brand">
          <img src="../assets/images/logo/logo.png" alt="TusCFDI" height="32" />
        </div>
        <div class="auth-link">
          <router-link :to="{ name: 'login' }" class="link">
            Inicio
          </router-link>
        </div>
      </div>

      <div class="row justify-content-center align-items-center min-vh-100">
        <div class="col-xl-5 col-lg-6 col-md-8 col-12">
          <div v-if="formError" class="alert alert-danger mb-3" role="alert">{{ formError }}</div>
          <PasswordStatusCard
            :email="email"
            :status="status"
            @verify="verifyCode"
            @save="savePassword"
            @retry="status = 'code'"
            @recover="goRecover"
            @login="goLogin"
          />
        </div>
      </div>

      <div class="auth-footer">
        <div class="footer-links">
          <a target="_blank" href="https://tuscfdis.com/terminos">Términos</a>
          <a target="_blank" href="https://tuscfdis.com/politica-privacidad">Privacidad</a>
        </div>
        <small>© 2026 TusCFDIs.</small>
      </div>
    </div>
  </div>
</template>

<script>
import PasswordStatusCard from '@/components/auth/passwordStatusCard.vue';
import ws from '@/services/login';

export default {
  name: 'new-password',
  components: {
    PasswordStatusCard
  },
  data() {
    const verifiedFromLink = String(this.$route?.query?.verified || '').trim() === '1';

    return {
      email: this.$route.query.email || '',
      status: verifiedFromLink ? 'reset' : 'code',
      formError: ''
    };
  },
  mounted() {
    if (!this.email) {
      this.formError = 'El enlace no contiene el correo';
      this.$router.push({ name: 'recoverPassword' });
      return;
    }

    if (String(this.$route?.query?.verified || '').trim() === '1') {
      this.$toast.success('Código validado. Define tu nueva contraseña.');
    }
  },
  methods: {
    async verifyCode(code) {
      this.formError = '';
      this.$loading.show();
      try {
        const res = await ws.verifyRecoverCode({
          email: this.email,
          code
        });

        if (res.type === 'success') {
          this.status = 'reset';
          this.$toast.success('Código válido. Ahora crea tu nueva contraseña');
          return;
        }

        this.status = 'error';
        this.formError = res.message || 'Código inválido';
      } catch (e) {
        this.status = 'error';
        this.formError = 'Código inválido o expirado';
      } finally {
        this.$loading.hide();
      }
    },

    async savePassword(payload) {
      this.formError = '';
      this.$loading.show();
      try {
        const res = await ws.newPassword({
          email: this.email,
          password: payload.password,
          password_confirmation: payload.password_confirmation
        });

        if (res.type === 'success') {
          this.status = 'success';
          this.$toast.success('Contraseña actualizada correctamente');
          this.$router.push({ name: 'login' });
          return;
        }

        this.formError = res.message || 'No se pudo actualizar la contraseña';
      } catch (e) {
        this.formError = 'Error al actualizar la contraseña';
      } finally {
        this.$loading.hide();
      }
    },

    goRecover() {
      this.$router.push({
        name: 'recoverPassword',
        query: { email: this.email || undefined }
      });
    },

    goLogin() {
      this.$router.push({ name: 'login' });
    }
  }
};
</script>
